import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        scores: { type: Object },
        type: { type: String },
    },
});
